import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_RuleTable = _resolveComponent("RuleTable")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                cols: "12",
                class: "my-3 justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_primary, {
                        block: "",
                        height: "40px",
                        elevation: "0",
                        class: "rounded-lg gradient",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routeAnalyseEdition())),
                        "data-cy": "WordingAnalysisTable-add"
                      }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode(" Ajouter ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "8",
                    class: "pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.search,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                        label: "Recherche",
                        "append-inner-icon": "$search",
                        clearable: "",
                        "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = '')),
                        "hide-details": "",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (!_ctx.useCompanyBTWordingPatterns)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "6",
                        class: "pl-2 pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            modelValue: _ctx.useOtherRules,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.useOtherRules) = $event)),
                            label: 'Utiliser les règles de bobbee et des autres cabinets'
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_RuleTable, {
            rule: 'wordingAnalysis',
            items: _ctx.items,
            actionFunction: _ctx.getActions,
            wordingFunction: _ctx.getWording,
            hideDuplication: true,
            pagination: _ctx.pagination,
            firstRequestDone: _ctx.firstRequestDone,
            patternCount: _ctx.patternCount,
            accountingCompanyId: _ctx.accountingCompanyId,
            maxHeight: _ctx.maxHeightRT,
            onToRoute: _cache[4] || (_cache[4] = ($event: any) => (_ctx.routeAnalyseEdition($event.id))),
            onDelete: _cache[5] || (_cache[5] = ($event: any) => {
                    _ctx.patternToDelete = $event;
                    _ctx.deleteDialog = true;
                })
          }, null, 8, ["items", "actionFunction", "wordingFunction", "pagination", "firstRequestDone", "patternCount", "accountingCompanyId", "maxHeight"])
        ]),
        _: 1
      }),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.deleteDialog,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.deleteDialog) = $event)),
        title: "Supprimer",
        error: true,
        onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.patternToDelete = undefined)),
        onValid: _ctx.deletePattern,
        validLoading: _ctx.deleteLoading,
        width: "800px"
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer cette règle ?", -1)
        ])),
        _: 1
      }, 8, ["modelValue", "onValid", "validLoading"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.analyseDialog,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.analyseDialog) = $event)),
        title: "Analyser",
        onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.analyseDialog = false)),
        onValid: _cache[10] || (_cache[10] = ($event: any) => (_ctx.analyse())),
        validLoading: _ctx.analyseLoading,
        width: "800px"
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createElementVNode("h4", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir analyser tous les dossiers ? ", -1)
        ])),
        _: 1
      }, 8, ["modelValue", "validLoading"])
    ]),
    _: 1
  }))
}